const KEY = 'staff-chat-sound';
export const CHAT_SOUND_EVENT = 'staff-chat-sound-change';
let context;
const watermarks = new Map();

export function chatSoundEnabled() {
  try { return localStorage.getItem(KEY) === 'on'; } catch { return false; }
}

export function unlockChatSound() {
  if (!chatSoundEnabled()) return;
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    context ||= new AudioContext();
    context.resume()?.catch(() => {});
  } catch { /* Audio permissions must not break messenger. */ }
}

export function setChatSoundEnabled(enabled) {
  try { localStorage.setItem(KEY, enabled ? 'on' : 'off'); } catch { return; }
  if (enabled) unlockChatSound();
  window.dispatchEvent(new Event(CHAT_SOUND_EVENT));
}

export function receiveChatActivity({ company_id, latest_unread_id }) {
  if (!company_id) return;
  const id = Number(latest_unread_id) || 0;
  const previous = watermarks.get(company_id);
  watermarks.set(company_id, Math.max(previous || 0, id));
  // Initial backlog, refreshes and read-all never play a sound.
  if (previous === undefined || id <= previous || !chatSoundEnabled() || context?.state !== 'running') return;
  try {
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const now = context.currentTime;
    oscillator.frequency.value = 740;
    gain.gain.setValueAtTime(0.09, now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.22);
    oscillator.connect(gain); gain.connect(context.destination);
    oscillator.start(now); oscillator.stop(now + 0.23);
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
  } catch { /* Browsers may suspend sound in the background. */ }
}
